import { forwardRef } from "react";
import { space } from "styled-system";
import styled from "styled-components";
import cx from "classnames";
import { SwitchRoot } from "../switch/switch";
import Label from "../label";
import Help from "../help";
import Flex from "../flex";
import "./style/index.css?global";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "field-control__Container",
  componentId: "sc-1w6h7u1-0"
})(["", " .form-control-children{", "{display:block;margin:5px 0;}textarea.ant-input{height:auto;margin-bottom:4px;}input[type=\"radio\"],input[type=\"checkbox\"]{width:14px;height:14px;}.ant-radio-wrapper,.ant-checkbox-wrapper{margin:7px 7px 7px 0;}.ant-radio-inline,.ant-checkbox-inline{display:inline-block;margin-left:8px;font-weight:normal;vertical-align:middle;cursor:pointer;&:first-child{margin-left:0;}}.ant-checkbox-vertical,.ant-radio-vertical{display:block;}.ant-checkbox-vertical + .ant-checkbox-vertical,.ant-radio-vertical + .ant-radio-vertical{margin-left:0;}.ant-select,.ant-picker{width:100%;}.ant-input-group .ant-select,.ant-input-group .ant-picker{width:auto;}}"], space, SwitchRoot);
export const FieldControl = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    label,
    htmlFor,
    extra,
    help,
    validateStatus = "default",
    showHelp = true,
    adminOnly = false,
    inline = false,
    className,
    children,
    ...rest
  } = _ref;
  const classString = cx(className, {
    "field-control-has-error": validateStatus === "error",
    "field-control-has-warning": validateStatus === "warning"
  });
  return /*#__PURE__*/_jsxs(Container, {
    ref: ref,
    mb: 3,
    className: classString,
    ...rest,
    children: [(label || extra) && /*#__PURE__*/_jsxs(Flex, {
      mb: 1,
      gap: 2,
      alignItems: "center",
      children: [label && /*#__PURE__*/_jsx(Label, {
        mb: 0,
        flex: "none",
        adminOnly: adminOnly,
        htmlFor: htmlFor,
        children: label
      }), extra, inline && /*#__PURE__*/_jsx(Flex, {
        as: "span",
        children: children
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      className: "form-control-children",
      children: [!inline && /*#__PURE__*/_jsx(Flex, {
        as: "span",
        children: children
      }), showHelp && /*#__PURE__*/_jsx(Help, {
        status: validateStatus,
        mt: 1,
        children: help
      })]
    })]
  });
});
export default FieldControl;